import React, { Component } from "react";
import SessionMenu from '../home/SessionMenu';
import MarketplaceLive from '../home/MarketplaceLive';
import MarketplaceOnDemand from '../home/MarketplaceOnDemand';
import MainLoader from '../home/MainLoader';
import classnames from "classnames";


class BookmarkedClasses extends Component {
  
  constructor(props) {
	super(props);
	
	this.state={
		chosenClassesMenu: 'Live',
		isOpenCancel: false,
		showLoader: false,
		isOpenDetailedClass: false
    }
	
}
 
componentDidMount(){
	
}

updateStateFromChild=(state)=>{
	this.setState(state);
	if ( state['isOpenCancel'] )
		{
			var bookScrollElement = document.getElementById('bookmarkScroll');
			bookScrollElement.scrollTop = 0;
		}
		
	if ( state['chosenClassesMenu'] )
		{
			this.closeDetails();
		}
}

closeDetails=()=>{
	this.setState({isOpenDetailedClass: false});
}

  render() {
	 return (
		<div className="booked_pop_content zIndex5">
			<div className={classnames({'bookmarked_content': true, 'hidden_overflow': this.state.isOpenCancel, 'detail_book_content': this.state.isOpenDetailedClass})} id="bookmarkScroll">
				<div className="close_pops"	onClick={() => this.props.updateStateFromChild({isOpenBookmark: false})}></div>
				<div className="video_name">Bookmarked Classes</div>
				<SessionMenu updateStateFromChild={this.updateStateFromChild} chosenClassesMenu={this.state.chosenClassesMenu} parentComponent='bookmarkClasses'></SessionMenu>
				<div className={"back_class_container " + ( !this.state.isOpenDetailedClass ? "d-none" : "" )}>
					<div className="arrow_back_content" onClick={this.closeDetails}>
						<div className="back_icon"></div>
						<div className="back_title">Back</div>
					</div>
				</div>
				<div className={( this.state.chosenClassesMenu !== 'Live' ? "d-none" : "" )}>
					{ !this.props.renderChild &&
						<MarketplaceLive
						state={this.state}
						updateStateFromChild={this.updateStateFromChild} 
						isOpenDetailedClass={this.state.isOpenDetailedClass}
						parentComponent='bookmarkClasses'
						history={this.props.history}></MarketplaceLive>
					}
				</div>
				<div className={( this.state.chosenClassesMenu !== 'On-demand' ? "d-none" : "" )}>
					<MarketplaceOnDemand 
					state={this.state}
					updateStateFromChild={this.updateStateFromChild} 
					isOpenDetailedClass={this.state.isOpenDetailedClass}
					parentComponent='bookmarkClasses'
					history={this.props.history}></MarketplaceOnDemand>
				</div>
			</div>
			{ this.state.showLoader && <MainLoader></MainLoader> }
		</div>
    );
  }
}
export default BookmarkedClasses;
